import React, { useState } from 'react';

import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import { PERMISSION, ROLE } from '../../helpers/Permissions';

import SuperAgentsList from './SuperAgentsList';

function SuperAgentPage() {
    const url = '/crea/api/super_agent';
    const title = 'All Super Agents';
    const [loading, setLoading] = useState(true);

    const getLinks = (id: number) => (
        <>
            <ViewButton url={`/super_agents/${id}`} permissions={[PERMISSION.VIEW_ADMIN]} />
            <EditButton
                url={`/super_agents/${id}/edit`}
                roles={[ROLE.MASTER_AGENT]}
                permissions={[PERMISSION.UPDATE_ADMIN]}
            />
            <DeleteButton
                url={`${url}/${id}`}
                action={() => setLoading(true)}
                permissions={[PERMISSION.DELETE_ADMIN]}
            />
        </>
    );

    return (
        <div>
            <ActionButton
                title="Create new super agent"
                url="/super_agents/create"
                permissions={[PERMISSION.CREATE_ADMIN]}
            />
            <SuperAgentsList
                url={url}
                cardTitle={title}
                getLinks={getLinks}
                loading={loading}
                setLoading={setLoading}
            />
        </div>
    );
}

export default SuperAgentPage;
